export const formatMaskPhone = (value) => {
  const numbers = value && value.match(/\d/g);
  let numberLength = 0;
  if (numbers) {
    numberLength = numbers.join('').length;
  }
  if (numberLength !== 10) {
    return ['(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  }

  return ['(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
};

export const formatTELEFONE = (numero) => {
  if (numero) {
    if (numero.length !== 10) {
      return numero.replace(/(\d{2})(\d{1})(\d{4})(\d{4})/g, '($1) $2 $3-$4');
    }
    return numero.replace(/(\d{2})(\d{4})(\d{4})/g, '($1) $2-$3');
  }
};
